import type { AnchorProtocol, BaseBreakPointProtocol, CursorProtocol, RichTextContentProtocol } from '../../protocols'
import type { EventsProtocol } from '../../protocols/event'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export enum QrBarcodeEnum {
    'QR_CODE' = 'QR_CODE',
    'BARCODE' = 'BARCODE'
}

export interface QrBarcodeBlockConfig extends BaseBreakPointProtocol, EventsProtocol, AnchorProtocol {
    codeType: QrBarcodeEnum
    content: {
        value: RichTextContentProtocol | undefined
    }
    barWidth?: number

    cursor?: CursorProtocol
}

export abstract class QrBarcodeBlockAbstract extends BaseBlock {
    type = BlockType.qrBarcode

    abstract override config: QrBarcodeBlockConfig
}
